import { render, staticRenderFns } from "./saleManage.vue?vue&type=template&id=5b6bec3e&scoped=true"
import script from "./saleManage.vue?vue&type=script&lang=js"
export * from "./saleManage.vue?vue&type=script&lang=js"
import style0 from "./saleManage.vue?vue&type=style&index=0&id=5b6bec3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6bec3e",
  null
  
)

export default component.exports